"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_UPLOAD_INPUT_STATUS = void 0;
exports.FILE_UPLOAD_INPUT_STATUS = {
    notReady: 'notReady',
    ready: 'ready',
    uploading: 'uploading',
    uploadComplete: 'uploadComplete',
    hasFile: 'hasFile',
    deleting: 'deleting',
    needsToReload: 'needsToReload',
};
